module.exports = __webpack_public_path__ + "static/02-fb4e95c7cea17cff9f1a1ccb989652dd.jpg";